export class SetEvent {
  static readonly type = '[Event] Set'
  constructor(public readonly event: Record<string, unknown>) {}
}

export class UpdateEventField {
  static readonly type = '[Event] Update Field'
  constructor(
    public readonly section: 'base' | 'sr-event',
    public readonly field: string,
    public readonly value: unknown,
  ) {}
}

export class ResetEvent {
  static readonly type = '[Event] Reset'
}
